export const getValidToken = async (keycloak) => {
  if (!keycloak.authenticated) {
    throw new Error('User not authenticated');
  }

  const tokenExpiry = keycloak.tokenParsed?.exp;
  const currentTime = Math.floor(Date.now() / 1000);
  const timeUntilExpiry = tokenExpiry - currentTime;

  if (timeUntilExpiry < 60) {
    try {
      await keycloak.updateToken(30);
    } catch (error) {
      console.error('Token refresh failed:', error);
      keycloak.logout({ redirectUri: window.location.origin });
      throw new Error('Session expired. Please log in again.');
    }
  }

  return keycloak.token;
};


